/**
 * Vue Router
 *
 * @author minkyoung.park@emcast.com
 */

// Components Define
import Vue from "vue";
import Router from "vue-router";
import loginApi from "@/api/loginApi.js";

import BrandSelect from "@/views/BrandSelect.vue";
import Login from "@/views/Login.vue";
import Home from "@/views/Home.vue";
import PcHome from "@/views/pc/Home.vue";
import BlockUser from "@/components/setting/blockUser/BlockUser.vue";
import Terms from "@/components/common/Terms.vue";
import Privacy from "@/components/common/Privacy.vue";
import TermsDetails from "@/components/common/termsDetails.vue";
import Certification from "@/views/Certification.vue";
import ErrorNetwork from "@/components/error/Network.vue";
import ReasonChoice from "@/components/common/reasonChoice/ReasonChoice.vue";
import Token from "@/views/Token";
// Reset Password
import ResetPw from "@/views/ResetPw.vue";

// Find Account
import FindId from "@/views/FindId.vue";
import FindIdStep1 from "@/components/findid/Step1.vue";
import FindIdStep2 from "@/components/findid/Step2.vue";
import FindIdStep3 from "@/components/findid/Step3.vue";
import FindIdStep4 from "@/components/findid/Step4.vue";
import FindIdComplete from "@/components/findid/Complete.vue";

// Find Code
import FindCode from "@/views/FindCode.vue";
import FindCodeStep1 from "@/components/findcode/Step1.vue";

// Find Password
import FindPw from "@/views/FindPw.vue";
import FindPwStep1 from "@/components/findpw/Step1.vue";
import FindPwStep2 from "@/components/findpw/Step2.vue";
import FindPwStep3 from "@/components/findpw/Step3.vue";
import FindPwStep4 from "@/components/findpw/Step4.vue";
import FindPwStep5 from "@/components/findpw/Step5.vue";
// import FindPwComplete from '@/components/findpw/Complete.vue'

// Sign Up
import Join from "@/views/Join.vue";
import JoinIntro from "@/components/join/Intro.vue";
import JoinRole from "@/components/join/Role.vue";
import JoinResponsibility from "@/components/join/Responsibility.vue";
import JoinPolicy from "@/components/join/Policy.vue";
import JoinTerms from "@/components/common/Terms.vue";
import JoinPrivacy from "@/components/common/Privacy.vue";
import JoinName from "@/components/join/Name.vue";
import JoinEmail from "@/components/join/Email.vue";
import JoinPassword from "@/components/join/Password.vue";
import JoinStore from "@/components/join/Store.vue";
import JoinComplete from "@/components/join/Complete.vue";
import JoinExistSocial from "@/components/join/ExistSocial.vue";
import JoinCode from "@/components/join/Code.vue";
import JoinSocialInput from "@/components/join/SocialInput.vue";

// New Sign Up
import Join2 from "@/views/Join2.vue";
import Join2Intro from "@/components/join2/Intro.vue";
import Join2Policy from "@/components/join2/Policy.vue";
import Join2Responsibility from "@/components/join2/Responsibility.vue";
import Join2Code from "@/components/join2/Code.vue";
import Join2Name from "@/components/join2/Name.vue";
import Join2Email from "@/components/join2/Email.vue";
import Join2Password from "@/components/join2/Password.vue";
import Join2RePassword from "@/components/join2/RePassword.vue";
import Join2Store from "@/components/join2/Store.vue";
import Join2CompleteApproved from "@/components/join2/CompleteApproved.vue";
import Join2CompleteUnapproved from "@/components/join2/CompleteUnapproved.vue";
import Join2SocialInput from "@/components/join2/SocialInput.vue";
import Join2ExistSocial from "@/components/join2/ExistSocial.vue";

// Member Withdrawal
import Withdrawal from "@/components/join/Withdrawal.vue";
import WithdrawalConfirm from "@/components/join/withdraw/WithdrawConfirm.vue";
import WithdrawalReason from "@/components/join/withdraw/WithdrawReason.vue";

// Dormancy
import Dormancy from "@/components/inActive/Dormancy.vue"

// Degree
import Degree from "@/views/Degree.vue";
import DegreeList from "../components/degree/List.vue";
import DegreeView from "@/components/degree/View.vue";
import DegreeNotice from "@/components/degree/view/Notice.vue";
import DegreeReviewList from "@/components/degree/review/List.vue";
import DegreeReviewPost from "@/components/degree/review/ReviewPost.vue";
import DegreeReviewEdit from "@/components/degree/review/ReviewEdit.vue";
import DegreeReviewList1 from "@/components/degree/review/ReviewListItem.vue";
// import DegreeLearnLesson from '@/components/degree/LearnLesson.vue'
import DegreeEnterAwait from "@/components/degree/EnterAwait.vue";

// Main Page
import Main from "@/components/main/Main";
import TagSerach from "@/components/main/TagSerach";
import TagSearchSurveyVA from "@/components/main/TagSearchSurveyVA";
import TagSearchCourseVA from "@/components/main/TagSearchCourseVA";
import TagSearchTestVA from "@/components/main/TagSearchTestVA";
import TagSearchCommunityVA from "@/components/main/TagSearchCommunityVA";
import TagSearchSocialVA from "@/components/main/tagSearchSocialVA";

// Learner
import Learn from "@/views/Learn.vue";
import LearnList from "../components/learn/List.vue";
import LearnView from "@/components/learn/View.vue";
import LearnViewMission from "@/components/learn/mission/View.vue";
import LearnViewMissionSubmit from "@/components/learn/mission/Submit.vue";
import LearnViewMissionViewSubmit from "@/components/learn/mission/ViewSubmit.vue";
import Study from "@/views/Study.vue";

// Micro Degree Learn
import MicroDegree from "@/views/MicroDegree.vue";
import MicroDegreeList from "../components/microLearn/List.vue";
import MicroDegreeView from "@/components/microLearn/View.vue";

import MicroDegreeReviewPost from "@/components/microDegree/review/ReviewPost.vue";
import MicroDegreeReviewEdit from "@/components/microDegree/review/ReviewEdit.vue";

// Micro Mission
import MicroMission from "@/components/microLearn/microMission/View.vue";
import MicroMissionSubmit from "@/components/microLearn/microMission/Submit.vue";
import MicroMissionViewSubmit from "@/components/microLearn/microMission/ViewSubmit.vue";

import MicroDegreeStudy from "@/views/MicroDegreeStudy";

// Micro Degree Chat
import MicroDegreeChat from "@/components/microQuestion/QuestionChatList.vue";

// Micro Degree Exam
import MicroExamIntro from "@/components/microExam/Intro.vue";
import MicroExamTake from "@/components/microExam/Take.vue";
import MicroExamResult from "@/components/microExam/Result.vue";
import MicroExamFeedback from "@/components/microExam/Feedback.vue";
import MicroExamFeedbackIssue from "@/components/microExam/FeedbackIssue.vue";

import MicroCourse from "@/views/MicroCourse";
import MicroCourseList from "@/components/microDegree/List";
import MicroCourseView from "@/components/microDegree/View";

// Leader Board
import Leader from "@/views/LeaderBoard.vue";

// Exam
import ExamIntro from "@/components/exam/Intro.vue";
import ExamTake from "@/components/exam/Take.vue";
import ExamResult from "@/components/exam/Result.vue";
import ExamFeedback from "@/components/exam/Feedback.vue";
import ExamFeedbackIssue from "@/components/exam/FeedbackIssue.vue";

// Sales
import Sales from "@/views/Sales.vue";
import SalesInformation from "@/components/sales/Information.vue";
import SalesResultEnroll from "@/components/sales/ResultEnroll.vue";
import SalesResultBank from "@/components/sales/ResultBank.vue";
import SalesResultPaypal from "@/components/sales/ResultPaypal.vue";
import SalesCart from "@/components/sales/Cart.vue";
import SalesDuplicate from "@/components/sales/Duplicate.vue";
import PaypalPaymentFail from "@/components/sales/PaypalPaymentFail.vue";

// Member
import Member from "@/views/Member.vue";
import StoreTransfer from "@/components/member/StoreTransfer.vue";
import EmailConfirm from "@/components/member/EmailConfirm.vue";
import EmailReconfirm from "@/components/member/EmailReconfirm.vue";
import MemberChangePassword from "@/components/member/ChangePassword.vue";
import MemberReIssueChangePassword from "@/components/member/ReIssueChangePassword.vue";
import MemberProfilePatten from "@/components/member/ProfilePatten.vue";
import MemberProfilePicture from "@/components/member/ProfilePicture.vue";
import MemberPurchase from "@/components/member/Purchase.vue";
import MemberPurchaseView from "@/components/member/PurchaseView.vue";
import MemberPurchaseRefund from "@/components/member/PurchaseRefund.vue";
import MemberPurchaseRefundBank from "@/components/member/PurchaseRefundBank.vue";
import MemberPurchaseUpdateRefund from "@/components/member/PurchaseUpdateRefund.vue";
import MemberPurchaseUpdateRefundBank from "@/components/member/PurchaseUpdateRefundBank.vue";
import MemberPurchaseRefundList from "@/components/member/PurchaseRefundList.vue";
import MemberPurchaseRefundView from "@/components/member/PurchaseRefundView.vue";
import MemberPurchaseQnA from "@/components/member/PurchaseQnA.vue";
import MyInformation from "@/components/member/MyInformation.vue";
import MemberDetail from "@/components/member/MemberDetail.vue";
import MemberDOB from "@/components/member/MemberDOB.vue";
import MemberPhoneNo from "@/components/member/MemberPhoneNo.vue";
import MyInfoChangePassword from "@/components/member/MyInfoChangePassword.vue";
import MyInfoChangePasswordStep3 from "@/components/member/MyInfoChangePasswordStep3.vue";
import MyInfoChangePasswordStep4 from "@/components/member/MyInfoChangePasswordStep4.vue";
import MyInfoChangePasswordStep5 from "@/components/member/MyInfoChangePasswordStep5.vue";
import MyInfoChangePasswordComplete from "@/components/member/MyInfoChangePasswordComplete.vue";

// Dynamic Link
import Dynamic from "@/views/Dynamic.vue";
import DynamicExam from "@/components/dynamic/Exam.vue";
import DynamicDegree from "@/components/dynamic/Degree.vue";
import DynamicLearn from "@/components/dynamic/Learn.vue";
import DynamicSurvey from "@/components/dynamic/Survey.vue";

// Independent Exam
import IndependentExam from "@/views/Exam.vue";
import IndependentExamTotalView from "@/components/independentExam/TotalView.vue";
import IndependentExamMyView from "@/components/independentExam/MyView.vue";
import IndependentExamResultView from "@/components/independentExam/ResultView.vue";

// Independent Survey
import IndependentSurvey from "@/views/Survey.vue";
import IndependentSurveyTotalView from "@/components/independentSurvey/TotalView.vue";
import SurveyIntro from "@/components/survey/Intro.vue";
import SurveyTake from "@/components/survey/Take.vue";
import SurveyResult from "@/components/survey/Result.vue";
import SurveyFeedback from "@/components/survey/Feedback.vue";
import SurveyInsightView from "@/components/independentSurvey/InsightView.vue";

// Question
import QuestionList from "@/components/question/List.vue";
import QuestionChat from "@/components/question/QuestionChatList.vue";
import ChatImageInLarge from "@/components/question/ChatImageInLarge";
// Sample UI
import Sample from "@/views/Sample.vue";

import Popup from "@/components/popup/Popup";
import Telegram from "@/components/popup/Telegram.vue";
import TelegramMessageAuth from "@/components/popup/TelegramMessageAuth.vue";

//six month not logged-in user
import ResetPassword from "@/components/sixmonth/ChangePassword.vue";

//Check responsibility verification code verified. (true / false) If false
import VerificationCode from "@/components/loginResponsibility/Code.vue";

//Check terms agree. (true/false) If false
import TermsAgree from "@/components/termsAgree/Policy.vue";

// HelpDesk
import HelpDesk from "@/views/HelpDesk.vue";
//import HelpDeskView from "@/components/helpDesk/View.vue";
import FaqDetail from "@/components/helpDesk/FaqDetail.vue";
// import FaqDetail2 from "@/components/helpDesk/FaqDetail2.vue";
// import InquiryDetail from "@/components/helpDesk/InquiryDetail.vue";
// import InquiryDetailComment from "@/components/helpDesk/InquiryDetailComment.vue";
// import InquiryDetailCommentImage from "@/components/helpDesk/InquiryDetailCommentImage.vue";
// import InquiryDetailCommentReply from "@/components/helpDesk/InquiryDetailCommentReply.vue";
import NoData from "@/components/helpDesk/NoData.vue";

import HtmlType from "@/components/htmlview/HtmlType.vue";

// import LearnViewMission from "@/components/learn/mission/View.vue";
// import LearnViewMissionSubmit from "@/components/learn/mission/Submit.vue";
// import Study from "@/views/Study.vue";

// Setting
import Languages from "@/views/Language";
import Setting from "@/components/setting/Setting";
import AccessRight from "@/views/access-right";
import AppVersion from "@/views/app-version";

//Subject
import Subject from "@/components/subject/Subject";

//Social Learning
import MyPost from "@/components/socialLearning/MyPost";
import DisplayFile from "@/components/socialLearning/DisplayFile";
import SLWrite from "@/components/socialLearning/social-learning-write";

// //Social Learning new
import SocialLearning from "@/views/SocialLearning.vue";
import SocialLearningList from "@/components/socialLearning/List.vue";
import SocialLearningView from "@/components/socialLearning/View.vue";

import Notice from "@/views/Notice.vue";
import NoticeDetail from "@/components/notice/NoticeDetail.vue";

//Point
import Point from "@/views/Point.vue";
import PointEarn from "@/views/PointEarn.vue";

//Reward
import Reward from "@/components/reward/Reward.vue";
import RewardBadgeList from "@/views/RewardBagde.vue";
import RewardCertificateList from "@/components/reward/CertificateList.vue";
import BadgeDetail from "@/components/reward/BadgeDetail.vue";
import BadgeAvailableDetail from "@/components/reward/BadgeAvailableDetail.vue";
import CertificateDetail from "@/components/reward/CertificateDetail.vue";

// Level
import Level from "@/components/level/Level.vue";

// Portfolio
import Portfolio from "@/components/portfolio/Portfolio.vue";
import BookMarkedLesson from "@/components/portfolio/BookMarkedLesson.vue";
import LikedLesson from "@/components/portfolio/LikedLesson.vue";
import SocialLearningLesson from "@/components/portfolio/SocialLearningLesson.vue";
import BookMarkedMission from "@/components/portfolio/BookMarkedMission.vue";

// //Social Learning new
import Forum from "@/views/Forum.vue";
//import SocialLearningList from "@/components/Forum/List.vue";
import ForumView from "@/components/forum/View";
import ForumWrite from "@/components/forum/write";
import ForumMyPost from "@/components/forum/MyPost";

//Report Issue
import Report from "@/views/ReportIssue.vue";
import ReportDetail from "@/components/reportQusetionIssue/ReportDetail.vue";

// License
import License from "@/components/license/License/";
import AddLicense from "@/components/license/AddLicense/";
import ModifyLicense from "@/components/license/ModifyLicense/";
import ModifyLicenseImage from "@/components/license/ModifyLicenseImage/";
import ViewLicense from "@/components/license/ViewLicense/";
import UploadLicense from "@/components/license/UploadLicense/";

// Board
import Board from "@/views/Board.vue";
import BoardList from "@/components/board/List.vue";
import BoardView from "@/components/board/View.vue";
import BoardWrite from "@/components/board/bord-write.vue";
import PerviewFile from "@/components/board/PerviewFile.vue";

// Store Management
import StoreManagement from "@/views/StoreManagement.vue";
import StoreView from "@/components/storeManagement/View.vue";
import StoreModify from "@/components/storeManagement/Modify.vue";
import StoreProductCategory from "@/components/storeManagement/ProductCategory.vue";
import StoreAdd from "@/components/storeManagement/Add.vue";
import BarCodeReader from "@/components/storeManagement/BarCodeReader.vue";

// CheckList
import Check from "@/views/CheckList.vue";
import CheckList from "@/components/checklist/List.vue";
import CheckListView from "@/components/checklist/View.vue";
import SubmittedResult from "@/components/checklist/SubmittedResult.vue";
import CheckListQuestionTake from "@/components/checklist/QuestionTake.vue";
import CheckListComment from "@/components/checklist/Comment.vue";
import TestCss from "@/components/common/TestCss.vue";

Vue.use(Router);

// Multi Language Set
import { setUserLanguage } from "@/translations/i18nSetup";
import brandApi from "@/api/brandApi.js";
import { log } from "util";
import LoginError from "@/views/LoginError";
import {storage} from "firebase";
import {storageConstants} from "@/utils/enum/StorageConstants";

// Auth Check
const requireAuth = (to, from, next) => {
  const toPath = encodeURIComponent(to.path);
  const loginPath = `/login?redirectPath=${toPath}`;

  console.log("from=>", from);
  console.log("to=>", to);

  if (localStorage.getItem("token")) {
    loginApi
      .validToken()
      .then(response => {
        next();
        return false;
      })
      .catch(err => {
        localStorage.removeItem("token");
        next(loginPath);
      });
  } else {
    next(loginPath);
  }
};

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/socialLearning/:board",
      name: "SocialLearning",
      component: SocialLearning,
      beforeEnter: requireAuth,
      meta: { TabType: "SocialLearningList", viewMode: "List" },
      children: [
        //     {
        //     path: "/",
        //     name: "SocialLearningList",
        //     component: SocialLearningList,
        //     beforeEnter: requireAuth,
        //     meta: { TabType: "SocialLearningView", viewMode: "List" },
        // },
        {
          path: ":postId",
          name: "SocialLearningView",
          component: SocialLearningView,
          beforeEnter: requireAuth,
          meta: { TabType: "SocialLearningView", viewMode: "View" }
        }
      ]
    },
    {
      path: "/file-display",
      name: "DisplayFile",
      beforeEnter: requireAuth,
      component: DisplayFile
    },
    {
      path: "/mypost",
      name: "MyPost",
      beforeEnter: requireAuth,
      component: MyPost
    },
    {
      path: "/social-learning/write",
      name: "SLWrite",
      beforeEnter: requireAuth,
      component: SLWrite
    },
    {
      path: "/social-learning/:postId/edit",
      name: "SLEdit",
      beforeEnter: requireAuth,
      component: SLWrite
    },
    {
      path: "/forum",
      name: "Forum",
      component: Forum,
      beforeEnter: requireAuth,
      meta: { TabType: "SocialLearningList", viewMode: "List" },
      children: [
        //     {
        //     path: "/",
        //     name: "SocialLearningList",
        //     component: SocialLearningList,
        //     beforeEnter: requireAuth,
        //     meta: { TabType: "SocialLearningView", viewMode: "List" },
        // },
        {
          path: ":postId",
          name: "ForumView",
          component: ForumView,
          beforeEnter: requireAuth,
          meta: { TabType: "ForumView", viewMode: "View" }
        }
      ]
    },
    {
      path: "/forum-mypost",
      name: "ForumMyPost",
      beforeEnter: requireAuth,
      component: ForumMyPost
    },
    {
      path: "/forums/write",
      name: "ForumWrite",
      beforeEnter: requireAuth,
      component: ForumWrite
    },
    {
      path: "/forums/:postId/edit",
      name: "ForumEdit",
      beforeEnter: requireAuth,
      component: ForumWrite
    },
    // {
    //     path: "/social_learning_listing_nodata",
    //     name: "SocialLearningNoData",
    //     beforeEnter: requireAuth,
    //     component: SocialLearningNoData,
    // },
    {
      path: "/notice",
      name: "notice",
      component: Notice,
      beforeEnter: requireAuth
    },
    {
      path: "/noticedetail/:id",
      name: "NoticeDetail",
      beforeEnter: requireAuth,
      component: NoticeDetail
    },
    {
      path: "/reward",
      name: "Reward",
      beforeEnter: requireAuth,
      component: Reward
    },
    {
      path: "/rewardbadgelist",
      name: "RewardBadgeList",
      component: RewardBadgeList,
      beforeEnter: requireAuth,
      meta: { TabType: "RewardBadgeList", viewMode: "RewardBadgeList" }
    },
    {
      path: "/rewardcertificatelist",
      name: "RewardCertificateList",
      component: RewardCertificateList,
      beforeEnter: requireAuth
      //meta: { TabType: "RewardCertificateList", viewMode: "RewardCertificateList" },
    },
    {
      path: "/point",
      name: "Point",
      beforeEnter: requireAuth,
      component: Point
    },
    {
      path: "/pointearn",
      name: "PointEarn",
      beforeEnter: requireAuth,
      component: PointEarn
    },
    {
      path: "/pointearn/:id",
      name: "PointEarn",
      beforeEnter: requireAuth,
      component: PointEarn
    },
    {
      path: "/badgedetail/:boxid/:missionid",
      name: "BadgeDetail",
      beforeEnter: requireAuth,
      component: BadgeDetail
    },
    {
      path: "/badgeavailabledetail/:id",
      name: "BadgeAvailableDetail",
      beforeEnter: requireAuth,
      component: BadgeAvailableDetail
    },
    {
      path: "/certificatedetail/:id",
      name: "CertificateDetail",
      beforeEnter: requireAuth,
      component: CertificateDetail
    },
    {
      path: "/level",
      name: "Level",
      beforeEnter: requireAuth,
      component: Level
    },
    {
      path: "/portfolio",
      name: "Portfolio",
      beforeEnter: requireAuth,
      component: Portfolio
    },
    {
      path: "/bookmarked-lesson",
      name: "BookMarkedLesson",
      beforeEnter: requireAuth,
      component: BookMarkedLesson
    },
    {
      path: "/liked-lesson",
      name: "LikedLesson",
      beforeEnter: requireAuth,
      component: LikedLesson
    },
    {
      path: "/social-lesson",
      name: "SocialLearningLesson",
      beforeEnter: requireAuth,
      component: SocialLearningLesson
    },
    {
      path: "/bookmarked-mission",
      name: "BookMarkedMission",
      beforeEnter: requireAuth,
      component: BookMarkedMission
    },
    {
      path: "/sample",
      name: "sample",
      component: Sample
    },

    {
      path: "/",
      name: "BrandSelect",
      component: BrandSelect
    },
    {
      path: "/subjects/:id?",
      name: "Subject",
      beforeEnter: requireAuth,
      component: Subject
    },
    {
      path: "/home",
      name: "Main",
      component: Main,
      meta: {
        title: localStorage.getItem("brandName"),
        leftButton: "menu"
      }
    },
    {
      path: "/tagsearch",
      name: "TagSearch",
      component: TagSerach,
      meta: {
        title: localStorage.getItem("brandName"),
        leftButton: "menu"
      }
    },
    {
      path: "/tagsearchsurvey",
      name: "TagSearchSurveyVA",
      component: TagSearchSurveyVA,
      meta: {
        title: localStorage.getItem("brandName"),
        leftButton: "menu"
      }
    },
    {
      path: "/tagsearchcourse",
      name: "TagSearchCourseVA",
      component: TagSearchCourseVA,
      meta: {
        title: localStorage.getItem("brandName"),
        leftButton: "menu"
      }
    },
    {
      path: "/tagsearchtest",
      name: "TagSearchTestVA",
      component: TagSearchTestVA,
      meta: {
        title: localStorage.getItem("brandName"),
        leftButton: "menu"
      }
    },
    {
      path: "/tagsearchsocial",
      name: "TagSearchSocialVA",
      component: TagSearchSocialVA,
      meta: {
        title: localStorage.getItem("brandName"),
        leftButton: "menu"
      }
    },
    {
      path: "/tagsearchcommunity",
      name: "TagSearchCommunityVA",
      component: TagSearchCommunityVA,
      meta: {
        title: localStorage.getItem("brandName"),
        leftButton: "menu"
      }
    },
    {
      path: "/login",
      name: "Login",
      component: Login
      // children: [
      //   {
      //     path: "policy",
      //     name: "SignInPolicy",
      //     component: JoinPolicy
      //   },
      //   { path: "/terms", name: "Terms", component: Terms },
      //   { path: "/privacy", name: "Privacy", component: Privacy },
      // ],
    },
     // 휴면회원처리 router
    {
      path: "/dormancy",
      name: "Dormancy",
      component: Dormancy,
    },
    {
      path: "/LoginError",
      name: "LoginError",
      component: LoginError
    },
    {
      path: "/token",
      name: "Token",
      component: Token
    },
    {
      path: "/terms",
      name: "Terms",
      component: Terms
    },
    {
      path: "/privacy",
      name: "Privacy",
      component: Privacy
    },
    {
      path: "/block-user",
      name: "BlockUser",
      component: BlockUser
    },
    {
      path: "/terms-details",
      name: "TermsDetails",
      component: TermsDetails
    },
    {
      path: "/emailvarification",
      name: "EmailConfirm",
      component: EmailConfirm,
      beforeEnter: requireAuth
    },
    {
      path: "/emailvarificationresend",
      name: "EmailReconfirm",
      component: EmailReconfirm,
      beforeEnter: requireAuth
    },

    {
      path: "/resetpw",
      name: "resetpw",
      component: ResetPw,
      beforeEnter: requireAuth,
      meta: {}
    },

    {
      path: "/resetpassword",
      name: "resetpassword",
      component: ResetPassword
    },

    {
      path: "/verificationcode",
      name: "verificationcode",
      component: VerificationCode
    },

    {
      path: "/termsagree",
      name: "termsagree",
      component: TermsAgree
    },

    {
      path: "/findid",
      name: "FindId",
      component: FindId,
      redirect: "/findid/step1",
      children: [
        { path: "step1", name: "FindIdStep1", component: FindIdStep1 },
        { path: "step2", name: "FindIdStep2", component: FindIdStep2 },
        { path: "step3", name: "FindIdStep3", component: FindIdStep3 },
        { path: "step4", name: "FindIdStep4", component: FindIdStep4 },
        { path: "complete", name: "FindIdComplete", component: FindIdComplete }
      ]
    },
    // develop by Ankit
    {
      path: "/findcode",
      name: "FindCode",
      component: FindCode,
      redirect: "/findcode/step1",
      children: [
        { path: "step1", name: "FindCodeStep1", component: FindCodeStep1 }
      ]
    },

    {
      path: "/findpw",
      name: "FindPw",
      component: FindPw,
      redirect: "/findpw/step1",
      children: [
        { path: "step1", name: "FindPwStep1", component: FindPwStep1 },
        { path: "step2", name: "FindPwStep2", component: FindPwStep2 },
        { path: "step3", name: "FindPwStep3", component: FindPwStep3 },
        { path: "step4", name: "FindPwStep4", component: FindPwStep4 },
        { path: "step5", name: "FindPwStep5", component: FindPwStep5 }
        // { path: 'complete', name: 'FindPwComplete', component: FindPwComplete },
      ]
    },

    {
      path: "/join",
      name: "Join",
      component: Join,
      redirect: "/join/intro",
      children: [
        { path: "intro", name: "JoinIntro", component: JoinIntro },
        { path: "role", name: "JoinRole", component: JoinRole },
        {
          path: "responsibility",
          name: "JoinResponsibility",
          component: JoinResponsibility
        },
        {
          path: "policy",
          name: "JoinPolicy",
          component: JoinPolicy,
          children: [
            { path: "terms", name: "JoinTerms", component: JoinTerms },
            { path: "privacy", name: "JoinPrivacy", component: JoinPrivacy }
          ]
        },
        { path: "name", name: "JoinName", component: JoinName },
        { path: "email", name: "JoinEmail", component: JoinEmail },
        { path: "password", name: "JoinPassword", component: JoinPassword },
        { path: "store", name: "JoinStore", component: JoinStore },
        { path: "complete", name: "JoinComplete", component: JoinComplete },
        {
          path: "existsocial",
          name: "JoinExistSocial",
          component: JoinExistSocial
        },
        { path: "code", name: "JoinCode", component: JoinCode },
        {
          path: "socialinput",
          name: "JoinSocialInput",
          component: JoinSocialInput
        }
      ]
    },

    {
      path: "/join2",
      name: "Join2",
      component: Join2,
      redirect: "/join2/intro",
      children: [
        { path: "intro", name: "Join2Intro", component: Join2Intro },
        {
          path: "policy",
          name: "Join2Policy",
          component: Join2Policy,
          children: [
            { path: "terms", name: "Join2Terms", component: JoinTerms },
            { path: "privacy", name: "Join2Privacy", component: JoinPrivacy }
          ]
        },

        {
          path: "responsibility",
          name: "Join2Responsibility",
          component: Join2Responsibility
        },
        { path: "code", name: "Join2Code", component: Join2Code },

        { path: "name", name: "Join2Name", component: Join2Name },
        { path: "email", name: "Join2Email", component: Join2Email },
        { path: "password", name: "Join2Password", component: Join2Password },
        {
          path: "repassword",
          name: "Join2RePassword",
          component: Join2RePassword
        },
        { path: "store", name: "Join2Store", component: Join2Store },
        {
          path: "completeapproved",
          name: "Join2CompleteApproved",
          component: Join2CompleteApproved
        },
        {
          path: "completeunapproved",
          name: "Join2CompleteUnapproved",
          component: Join2CompleteUnapproved
        },
        {
          path: "existsocial",
          name: "Join2ExistSocial",
          component: Join2ExistSocial
        },
        {
          path: "socialinput",
          name: "Join2SocialInput",
          component: Join2SocialInput
        }
      ]
    },

    {
      path: "/degree",
      name: "Degree",
      component: Degree,
      meta: { TabType: "DegreeList", viewMode: "List" },
      children: [
        {
          path: "/",
          name: "DegreeList",
          component: DegreeList,
          meta: { TabType: "DegreeList", viewMode: "List" }
        },
        {
          path: ":degreeId",
          name: "DegreeView",
          component: DegreeView,
          meta: { TabType: "", viewMode: "View" },
          children: [
            {
              path: "review",
              name: "DegreeReviewList",
              component: DegreeReviewList,
              props: true,
              meta: { TabType: "DegreeList", viewMode: "View" }
            },
            // {path: 'learn/:lessonId', name: 'DegreeLearnLesson', component: DegreeLearnLesson, props: true, meta: {TabType: 'DegreeList', viewMode: 'View'} },
            {
              path: "enterawait",
              name: "DegreeEnterAwait",
              component: DegreeEnterAwait,
              props: true,
              meta: { TabType: "DegreeList", viewMode: "View" }
            }
          ]
        }
      ]
    },
    {
      path: "/review-list/:id",
      name: "DegreeReviewList1",
      beforeEnter: requireAuth,
      component: DegreeReviewList1
      //props: true,
      // meta: { TabType: "DegreeList", viewMode: "View" },
    },
    {
      path: "/review-post/:id",
      name: "DegreeReviewPost",
      beforeEnter: requireAuth,
      component: DegreeReviewPost
    },
    {
      path: "/review-edit/:degreeId/:id",
      name: "DegreeReviewEdit",
      beforeEnter: requireAuth,
      component: DegreeReviewEdit
    },
    // {
    //   path: "/main",
    //   name: "main",
    //   component: Main,
    //   beforeEnter: requireAuth,
    //   meta: {},
    // },
    {
      path: "/learn/:learnId/:lessonId/lessonContents/:progressionId",
      name: "LessonViewLearn",
      component: Study,
      beforeEnter: requireAuth,
      meta: { TabType: "LearnList", viewMode: "View" },
      children: [
        {
          path: "question",
          name: "LessonViewQuestionLearn",
          component: QuestionList,
          beforeEnter: requireAuth,
          meta: {
            TabType: "LearnList",
            viewMode: "View",
            chatType: "lesson"
          }
        }
      ]
    },
    {
      path: "/learn-study/:learnId/:lessonId/lessonContents/:progressionId",
      name: "LessonView",
      component: Study,
      beforeEnter: requireAuth,
      meta: { TabType: "LearnList", viewMode: "View" },
      children: [
        {
          path: "question",
          name: "LessonViewQuestion",
          component: QuestionList,
          beforeEnter: requireAuth,
          meta: {
            TabType: "LearnList",
            viewMode: "View",
            chatType: "lesson"
          }
        }
      ]
    },
    {
      path: "/learn",
      name: "Learn",
      component: Learn,
      // beforeEnter: requireAuth,
      meta: { TabType: "LearnList", viewMode: "List" },
      children: [
        {
          path: "/",
          name: "LearnList",
          component: LearnList,
          meta: { TabType: "LearnList", viewMode: "List" }
        },

        {
          path: ":learnId",
          name: "LearnView",
          component: LearnView,
          beforeEnter: requireAuth,
          meta: { TabType: "LearnList", viewMode: "View" },
          children: [
            {
              path: ":lessonId/question",
              name: "LearnViewQuestion",
              component: QuestionChat,
              beforeEnter: requireAuth,
              meta: {
                TabType: "LearnList",
                viewMode: "View",
                chatType: "lesson"
              }
            },

            {
              path: "lessonExam/:examineeId/intro",
              name: "LessonExamIntro",
              component: ExamIntro,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" }
            },
            {
              path: "lessonExam/:examineeId/take",
              name: "LessonExamTake",
              component: ExamTake,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" }
            },
            {
              path: "lessonExam/:examineeId/result",
              name: "LessonExamResult",
              component: ExamResult,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" }
            },
            {
              path: "lessonExam/:examineeId/feedback/:paperId",
              name: "LessonExamFeedback",
              component: ExamFeedback,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" },
              children: [
                {
                  path: "issue/:questionId",
                  name: "LessonExamFeedbackIssue",
                  component: ExamFeedbackIssue,
                  beforeEnter: requireAuth,
                  meta: { TabType: "LearnList", viewMode: "View" }
                },
                {
                  path: "question/:questionId",
                  name: "LessonExamFeedbackQuestion",
                  component: QuestionList,
                  beforeEnter: requireAuth,
                  meta: {
                    TabType: "LearnList",
                    viewMode: "View",
                    chatType: "exam"
                  }
                }
              ]
            },

            {
              path: "finalExam/:examineeId/intro",
              name: "FinalExamIntro",
              component: ExamIntro,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" }
            },
            {
              path: "finalExam/:examineeId/take",
              name: "FinalExamTake",
              component: ExamTake,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" }
            },
            {
              path: "finalExam/:examineeId/result",
              name: "FinalExamResult",
              component: ExamResult,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" }
            },
            {
              path: "finalExam/:examineeId/feedback/:paperId",
              name: "FinalExamFeedback",
              component: ExamFeedback,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" },
              children: [
                {
                  path: "issue/:questionId",
                  name: "FinalExamFeedbackIssue",
                  component: ExamFeedbackIssue,
                  beforeEnter: requireAuth,
                  meta: { TabType: "LearnList", viewMode: "View" }
                },
                {
                  path: "question/:questionId",
                  name: "FinalExamFeedbackQuestion",
                  component: QuestionChat,
                  beforeEnter: requireAuth,
                  meta: {
                    TabType: "LearnList",
                    viewMode: "View",
                    chatType: "exam"
                  }
                }
              ]
            },
            {
              path: "mission/:assignmentId/viewsubmit",
              name: "LearnViewMissionViewSubmit",
              component: LearnViewMissionViewSubmit,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" }
            },
            {
              path: "mission/:assignmentId",
              name: "LearnViewMission",
              component: LearnViewMission,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" }
            },
            {
              path: "submit",
              name: "LearnViewMissionSubmit",
              component: LearnViewMissionSubmit,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" }
            },
            {
              path: "mission/:assignmentId/update/:answerId",
              name: "LearnViewMissionUpdate",
              component: LearnViewMissionSubmit,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" }
            },
            {
              path: "question/:lessonId/:roomId",
              name: "LessonQuestion",
              component: QuestionList,
              beforeEnter: requireAuth,
              meta: {
                TabType: "LearnList",
                viewMode: "View",
                chatType: "lesson"
              }
            }
          ]
        }
      ]
    },
    {
      path: "/micro-course",
      name: "MicroCourse",
      component: MicroCourse,
      beforeEnter: requireAuth,
      meta: { TabType: "LearnList", viewMode: "List" },
      children: [
        {
          path: "/",
          name: "MicroCourseList",
          component: MicroCourseList,
          beforeEnter: requireAuth,
          meta: { TabType: "LearnList", viewMode: "List" },
          children: []
        },
        {
          path: ":degreeId",
          name: "MicroCourseView",
          component: MicroCourseView,
          beforeEnter: requireAuth,
          meta: { TabType: "LearnList", viewMode: "View" }
        },
        {
          path: "/micro/review-post/:id",
          name: "MicroDegreeReviewPost",
          beforeEnter: requireAuth,
          component: MicroDegreeReviewPost
        },
        {
          path: "/micro/review-edit/:degreeId/:id",
          name: "MicroDegreeReviewEdit",
          beforeEnter: requireAuth,
          component: MicroDegreeReviewEdit
        }
      ]
    },

    {
      path: "/micro-study/:learnId/:lessonId/lessonContents/:progressionId",
      name: "MicroDegreeLessonView",
      component: MicroDegreeStudy,
      beforeEnter: requireAuth,
      meta: { TabType: "LearnList", viewMode: "View" },
      children: [
        {
          path: "question",
          name: "MicroDegreeLessonViewQuestion",
          component: MicroDegreeChat,
          beforeEnter: requireAuth,
          meta: {
            TabType: "LearnList",
            viewMode: "View",
            chatType: "lesson"
          }
        }
      ]
    },

    {
      path: "/micro",
      name: "MicroDegree",
      component: MicroDegree,
      beforeEnter: requireAuth,
      meta: { TabType: "LearnList", viewMode: "List" },
      children: [
        {
          path: "/",
          name: "MicroDegreeList",
          component: MicroDegreeList,
          beforeEnter: requireAuth,
          meta: { TabType: "LearnList", viewMode: "List" }
        },
        {
          path: ":learnId",
          name: "MicroDegreeView",
          component: MicroDegreeView,
          beforeEnter: requireAuth,
          meta: { TabType: "LearnList", viewMode: "View" },
          children: [
            {
              path: ":lessonId/question",
              name: "MicroDegreeViewQuestion",
              component: MicroDegreeChat,
              beforeEnter: requireAuth,
              meta: {
                TabType: "LearnList",
                viewMode: "View",
                chatType: "lesson"
              }
            },
            {
              path: "lessonExam/:examineeId/intro",
              name: "MicroExamIntro",
              component: MicroExamIntro,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" }
            },
            {
              path: "lessonExam/:examineeId/take",
              name: "MicroExamTake",
              component: MicroExamTake,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" }
            },
            {
              path: "lessonExam/:examineeId/result",
              name: "MicroExamResult",
              component: MicroExamResult,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" }
            },
            {
              path: "lessonExam/:examineeId/feedback/:paperId",
              name: "MicroExamFeedback",
              component: MicroExamFeedback,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" },
              children: [
                {
                  path: "issue/:questionId",
                  name: "MicroExamFeedbackIssue",
                  component: MicroExamFeedbackIssue,
                  beforeEnter: requireAuth,
                  meta: { TabType: "LearnList", viewMode: "View" }
                },
                {
                  path: "question/:questionId",
                  name: "MicroExamFeedbackQuestion",
                  component: MicroDegreeChat,
                  beforeEnter: requireAuth,
                  meta: {
                    TabType: "LearnList",
                    viewMode: "View",
                    chatType: "exam"
                  }
                }
              ]
            },

            {
              path: "finalExam/:examineeId/intro",
              name: "FinalMicroExamIntro",
              component: MicroExamIntro,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" }
            },
            {
              path: "finalExam/:examineeId/take",
              name: "FinalMicroExamTake",
              component: MicroExamTake,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" }
            },
            {
              path: "finalExam/:examineeId/result",
              name: "FinalMicroExamResult",
              component: MicroExamResult,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" }
            },
            {
              path: "finalExam/:examineeId/feedback/:paperId",
              name: "FinalMicroExamFeedback",
              component: MicroExamFeedback,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" },
              children: [
                {
                  path: "issue/:questionId",
                  name: "FinalMicroExamFeedbackIssue",
                  component: MicroExamFeedbackIssue,
                  beforeEnter: requireAuth,
                  meta: { TabType: "LearnList", viewMode: "View" }
                },
                {
                  path: "question/:questionId",
                  name: "FinalMicroExamFeedbackQuestion",
                  component: MicroDegreeChat,
                  beforeEnter: requireAuth,
                  meta: {
                    TabType: "LearnList",
                    viewMode: "View",
                    chatType: "exam"
                  }
                }
              ]
            },
            {
              path: "mission/:assignmentId/viewsubmit",
              name: "MicroMissionViewSubmit",
              component: MicroMissionViewSubmit,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" }
            },
            {
              path: "mission/:assignmentId",
              name: "MicroMission",
              component: MicroMission,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" },
            },
            {
              path: "submit",
              name: "MicroMissionSubmit",
              component: MicroMissionSubmit,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" }
            },

            {
              path: "mission/:assignmentId/update/:answerId",
              name: "MicroMissionUpdate",
              component: MicroMissionSubmit,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" }
            },
            {
              path: "question/:lessonId/:roomId",
              name: "LessonQuestion",
              component: MicroDegreeChat,
              beforeEnter: requireAuth,
              meta: {
                TabType: "LearnList",
                viewMode: "View",
                chatType: "lesson"
              }
            }
          ]
        }
      ]
    },
    {
      path: "/leader",
      name: "Leader",
      component: Leader,
      beforeEnter: requireAuth,
      meta: { TabType: "LeaderList", viewMode: "List" }
    },

    {
      path: "/popup",
      name: "Popup",
      component: Popup,
      // PC 모바일 타블렛 화면 분기 위한 개발 코드
      // components: {
      //     default: Home,
      //     pcRouter: PcHome
      // },
      meta: {
        title: localStorage.getItem("brandName"),
        leftButton: "menu"
      }
    },

    {
      path: "/Telegram",
      name: "Telegram",
      component: Telegram
    },

    {
      path: "/TelegramMessageAuth",
      name: "TelegramMessageAuth",
      component: TelegramMessageAuth
    },

    {
      path: "/study/:learnId/:progressionId",
      name: "study",
      component: Study,
      beforeEnter: requireAuth,
      meta: {}
    },

    {
      path: "/sales",
      name: "Sales",
      component: Sales,
      beforeEnter: requireAuth,
      children: [
        {
          path: "duplicate/:goodsid",
          name: "SalesDuplicate",
          component: SalesDuplicate,
          beforeEnter: requireAuth,
          meta: { TabType: "" }
        },
        {
          path: "information/:goodsid",
          name: "SalesInformation",
          component: SalesInformation,
          beforeEnter: requireAuth,
          meta: { TabType: "" }
        },
        {
          path: "cart/:goodsid",
          name: "SalesCart",
          component: SalesCart,
          beforeEnter: requireAuth,
          meta: { TabType: "" }
        },

        {
          path: "resultbank/:orderId",
          name: "SalesResultBank",
          component: SalesResultBank,
          beforeEnter: requireAuth,
          meta: { TabType: "" }
        },
        {
          path: "resultpaypal/:orderId",
          name: "SalesResultPaypal",
          component: SalesResultPaypal,
          beforeEnter: requireAuth,
          meta: { TabType: "" }
        },
        {
          path: "resultenroll/:orderId",
          name: "SalesResultEnroll",
          component: SalesResultEnroll,
          beforeEnter: requireAuth,
          meta: { TabType: "" }
        },
        {
          path: "paymentfail",
          name: "PaypalPaymentFail",
          component: PaypalPaymentFail,
          beforeEnter: requireAuth,
          meta: { TabType: "" }
        }
      ]
    },

    // {
    // 	path: "/sales/cart/:goodsid",
    // 	name: "SalesCart",
    // 	component: SalesCart,
    // 	beforeEnter: requireAuth,
    // 	meta: { TabType: "" },
    // },

    {
      path: "/member",
      name: "Member",
      component: Member,
      redirect: "",
      children: [
        {
          path: "changepassword",
          name: "MemberChangePassword",
          component: MemberChangePassword,
          beforeEnter: requireAuth
        },
        {
          path: "reissuechangepassword",
          name: "MemberReIssueChangePassword",
          component: MemberReIssueChangePassword,
          beforeEnter: requireAuth
        },
        {
          path: "profilePatten",
          name: "MemberProfilePatten",
          component: MemberProfilePatten,
          beforeEnter: requireAuth
        },
        {
          path: "profilePicture",
          name: "MemberProfilePicture",
          component: MemberProfilePicture,
          beforeEnter: requireAuth
        },
        {
          path: "myinfo",
          name: "MyInformation",
          component: MyInformation,
          beforeEnter: requireAuth
        },
        {
          path: "memberdetail",
          name: "MemberDetail",
          component: MemberDetail,
          beforeEnter: requireAuth
        },
        {
          path: "myphone",
          name: "MemberPhoneNo",
          component: MemberPhoneNo,
          beforeEnter: requireAuth
        },
        {
          path: "memberDOB",
          name: "MemberDOB",
          component: MemberDOB,
          beforeEnter: requireAuth
        },
        {
          path: "myinfochangepassword",
          name: "MyInfoChangePassword",
          component: MyInfoChangePassword,
          beforeEnter: requireAuth
        },
        {
          path: "myinfochangepasswordstep3",
          name: "MyInfoChangePasswordStep3",
          component: MyInfoChangePasswordStep3
        },
        {
          path: "myinfochangepasswordstep4",
          name: "MyInfoChangePasswordStep4",
          component: MyInfoChangePasswordStep4
        },
        {
          path: "myInfochangepasswordstep5",
          name: "MyInfoChangePasswordStep5",
          component: MyInfoChangePasswordStep5
        },
        {
          path: "myinfoChangepasswordcomplete",
          name: "MyInfoChangePasswordComplete",
          component: MyInfoChangePasswordComplete
        },
        {
          path: "Withdrawal",
          name: "Withdrawal",
          component: Withdrawal,
          beforeEnter: requireAuth
        },
        {
          path: "withdraw-confirm",
          name: "WithdrawalConfirm",
          component: WithdrawalConfirm,
          beforeEnter: requireAuth
        },
        {
            path: "withdraw-reason",
            name: "WithdrawalReason",
            component: WithdrawalReason,
            beforeEnter: requireAuth
        },
        {
          path: "purchase",
          name: "MemberPurchase",
          component: MemberPurchase,
          beforeEnter: requireAuth,
          children: [
            // {
            // 	path: ":orderId",
            // 	name: "MemberPurchaseView",
            // 	component: MemberPurchaseView,
            // 	beforeEnter: requireAuth,
            // },
            // {
            // 	path: "qna/:orderId",
            // 	name: "MemberPurchaseQnA",
            // 	component: MemberPurchaseQnA,
            // 	beforeEnter: requireAuth,
            // },
          ]
        },

        {
          path: "qna/:orderId",
          name: "MemberPurchaseQnA",
          component: MemberPurchaseQnA,
          beforeEnter: requireAuth
        },

        {
          path: "refund/:orderId",
          name: "MemberPurchaseRefund",
          component: MemberPurchaseRefund,
          beforeEnter: requireAuth
        },
        {
          path: "refundbank/:orderId",
          name: "MemberPurchaseRefundBank",
          component: MemberPurchaseRefundBank,
          beforeEnter: requireAuth
        },
        {
          path: "orderdetail/:orderId",
          name: "MemberPurchaseView",
          component: MemberPurchaseView,
          beforeEnter: requireAuth
        },
        {
          path: "refundlist",
          name: "MemberPurchaseRefundList",
          component: MemberPurchaseRefundList,
          beforeEnter: requireAuth
          // children: [
          // 	{
          // 		path: ":orderId",
          // 		name: "MemberPurchaseRefundView",
          // 		component: MemberPurchaseRefundView,
          // 		beforeEnter: requireAuth,
          // 	},
          // ],
        },
        {
          path: "refundlist/:orderId",
          name: "MemberPurchaseRefundView",
          component: MemberPurchaseRefundView,
          beforeEnter: requireAuth
        },
        {
          path: "refundupdate/:orderId",
          name: "MemberPurchaseUpdateRefund",
          component: MemberPurchaseUpdateRefund,
          beforeEnter: requireAuth
        },
        {
          path: "refundupdateBank/:orderId",
          name: "MemberPurchaseUpdateRefundBank",
          component: MemberPurchaseUpdateRefundBank,
          beforeEnter: requireAuth
        }
      ]
    },
    // {
    //   path: "myinfo",
    //   name: "MemberDetail",
    //   component: MemberDetail,
    //   beforeEnter: requireAuth,
    // },
    {
      path: "/certification",
      name: "certification",
      component: Certification,
      beforeEnter: requireAuth,
      meta: {}
    },

    {
      path: "/reason-choice",
      name: "ReasonChoice",
      component: ReasonChoice,
      beforeEnter: requireAuth,
      meta: {}
    },

    {
      path: "/error",
      name: "Error",
      component: Error,
      meta: {},
      children: [{ path: "network", name: "Network", component: ErrorNetwork }]
    },

    {
      path: "/dynamic",
      name: "Dynamic",
      component: Dynamic,
      children: [
        {
          path: ":brandCode/exam/:distId",
          name: "DynamicExam",
          component: DynamicExam
        },
        {
          path: ":brandCode/degree",
          name: "DynamicDegree",
          component: DynamicDegree
        },
        {
          path: ":brandCode/degree/:degreeId",
          name: "DynamicDegreeView",
          component: DynamicDegree
        },
        {
          path: ":brandCode/learn",
          name: "DynamicLearn",
          component: DynamicLearn
        },
        {
          path: ":brandCode/survey/:distId",
          name: "DynamicSurvey",
          component: DynamicSurvey
        }
      ]
    },

    // 단독 시험
    {
      path: "/independent/exam",
      name: "IndependentExam",
      component: IndependentExam,
      meta: { TabType: "ExamList", viewMode: "List" },
      children: [
        {
          path: ":distId",
          name: "IndependentExamTotalView",
          component: IndependentExamTotalView,
          meta: { TabType: "ExamList", viewMode: "View" }
        },
        {
          path: "my/:examineeId",
          name: "IndependentExamMyView",
          beforeEnter: requireAuth,
          component: IndependentExamMyView,
          meta: { TabType: "ExamList", viewMode: "View" },
          children: [
            {
              path: "intro",
              name: "IndependentExamIntro",
              component: ExamIntro,
              meta: { TabType: "ExamList", viewMode: "View" }
            },
            {
              path: "take",
              name: "IndependentExamTake",
              component: ExamTake,
              meta: { TabType: "ExamList", viewMode: "View" }
            }
          ]
        },
        {
          path: "result/:examineeId",
          name: "IndependentExamResultView",
          beforeEnter: requireAuth,
          component: IndependentExamResultView,
          meta: { TabType: "ExamList", viewMode: "View" },
          children: [
            {
              path: "take",
              name: "IndependentExamResultTake",
              component: ExamTake,
              meta: { TabType: "ExamList", viewMode: "View" }
            },
            {
              path: "result",
              name: "IndependentExamResultResult",
              component: ExamResult,
              meta: { TabType: "ExamList", viewMode: "View" }
            },
            {
              path: "feedback/:paperId",
              name: "IndependentExamResultFeedback",
              component: ExamFeedback,
              meta: { TabType: "ExamList", viewMode: "View" },
              children: [
                {
                  path: "issue/:questionId",
                  name: "IndependentExamResultFeedbackIssue",
                  component: ExamFeedbackIssue,
                  meta: { TabType: "ExamList", viewMode: "View" }
                },
                {
                  path: "question/:questionId",
                  name: "IndependentExamResultFeedbackQuestion",
                  component: QuestionChat,
                  meta: {
                    TabType: "ExamList",
                    viewMode: "View",
                    chatType: "exam"
                  }
                }
              ]
            }
          ]
        }
      ]
    },

    // 단독 설문
    {
      path: "/independent/survey",
      name: "IndependentSurvey",
      component: IndependentSurvey,
      meta: { TabType: "SurveyList", viewMode: "List" },
      children: [
        {
          path: ":distId",
          name: "IndependentSurveyTotalView",
          component: IndependentSurveyTotalView,
          meta: { TabType: "SurveyList", viewMode: "View" },
          children: [
            {
              path: ":respondentId/intro",
              name: "IndependentSurveyIntro",
              beforeEnter: requireAuth,
              component: SurveyIntro,
              meta: { TabType: "SurveyList", viewMode: "View" }
            },
            {
              path: ":respondentId/take",
              name: "IndependentSurveyTake",
              beforeEnter: requireAuth,
              component: SurveyTake,
              meta: { TabType: "SurveyList", viewMode: "View" }
            },
            {
              path: ":respondentId/result",
              name: "IndependentSurveyResult",
              beforeEnter: requireAuth,
              component: SurveyResult,
              meta: { TabType: "SurveyList", viewMode: "View" }
            },
            {
              path: ":respondentId/feedback",
              name: "IndependentSurveyFeedback",
              beforeEnter: requireAuth,
              component: SurveyFeedback,
              meta: { TabType: "SurveyList", viewMode: "View" }
            }
          ]
        }
      ]
      // children: [{
      //   path: ":distributionId",
      //   name: "SurveyInsightView",
      //   beforeEnter: requireAuth,
      //   component: SurveyInsightView,
      // }],
    },
    {
      path: "/independent/survey/:distId",
      name: "SurveyInsightView",
      beforeEnter: requireAuth,
      component: SurveyInsightView
    },

    //Social Learning module
    // {
    //   path: "/social_learning_listing",
    //   name: "SocialLearningListing",
    //   beforeEnter: requireAuth,
    //   component: SocialLearningListing,
    // },
    // {
    //   path: "/social_learning_listing_nodata",
    //   name: "SocialLearningNoData",
    //   beforeEnter: requireAuth,
    //   component: SocialLearningNoData,
    // },
    // {
    //   path: "/social_learning_details",
    //   name: "SocialLearningDetails",
    //   beforeEnter: requireAuth,
    //   component: SocialLearningDetails,
    // },
    // {
    //   path: "/social_learning_comments",
    //   name: "SocialLearningComments",
    //   beforeEnter: requireAuth,
    //   component: SocialLearningComments,
    // },
    // {
    //   path: "/social_learning_overflow_menu",
    //   name: "SocialLearningOverflowMenu",
    //   beforeEnter: requireAuth,
    //   component: SocialLearningOverflowMenu,
    // },
    // {
    //   path: "/social_learning_overflow_menu_mypost",
    //   name: "SocialLearningOverflowMenuMyPost",
    //   beforeEnter: requireAuth,
    //   component: SocialLearningOverflowMenuMyPost,
    // },
    // {
    //   path: "/social_learning_overflow_menu_searchpost",
    //   name: "SocialLearningOverflowMenuSearchPost",
    //   beforeEnter: requireAuth,
    //   component: SocialLearningOverflowMenuSearchPost,
    // },
    // {
    //   path: "/social_learning_overflow_menu_nosearch",
    //   name: "SocialLearningOverflowMenuNoSearchResult",
    //   beforeEnter: requireAuth,
    //   component: SocialLearningOverflowMenuNoSearchResult,
    // },
    // {
    //   path: "/social_learning_overflow_menu_searchresults",
    //   name: "SocialLearningOverflowMenuSearchResult",
    //   beforeEnter: requireAuth,
    //   component: SocialLearningOverflowMenuSearchResult,
    // },
    {
      path: "/languages",
      name: "languages",
      beforeEnter: requireAuth,
      component: Languages
    },

    {
      path: "/setting",
      name: "setting",
      beforeEnter: requireAuth,
      component: Setting
    },

    {
      path: "/access-right",
      name: "access-right",
      beforeEnter: requireAuth,
      component: AccessRight
    },

    {
      path: "/app-version",
      name: "app-version",
      beforeEnter: requireAuth,
      component: AppVersion
    },
    {
      path: "/helpdesk",
      name: "helpdesk",
      component: HelpDesk,
      beforeEnter: requireAuth
      // meta: { TabType: "HelpDeskList", viewMode: "List" },
    },
    {
      path: "/nodata",
      name: "NoData",
      beforeEnter: requireAuth,
      component: NoData
    },
    {
      path: "/faqdetail/:id",
      name: "FaqDetail",
      beforeEnter: requireAuth,
      component: FaqDetail
    },
    // {
    //   path: "/faq-detail/:id",
    //   name: "FaqDetail2",
    //   beforeEnter: requireAuth,
    //   component: FaqDetail2
    // },
    // {
    //   path: "/inquiry-detail",
    //   name: "InquiryDetail",
    //   beforeEnter: requireAuth,
    //   component: InquiryDetail
    // },
    // {
    //   path: "/inquiry-detail-comment",
    //   name: "InquiryDetailComment",
    //   beforeEnter: requireAuth,
    //   component: InquiryDetailComment
    // },
    // {
    //   path: "/inquiry-detail-comment-image",
    //   name: "InquiryDetailCommentImage",
    //   beforeEnter: requireAuth,
    //   component: InquiryDetailCommentImage
    // },
    // {
    //   path: "/inquiry-detail-comment-reply",
    //   name: "InquiryDetailCommentReply",
    //   beforeEnter: requireAuth,
    //   component: InquiryDetailCommentReply
    // },
    {
      path: "/html-view",
      name: "HtmlType",
      beforeEnter: requireAuth,
      component: HtmlType
    },
    {
      path: "/report",
      name: "Report",
      beforeEnter: requireAuth,
      component: Report
    },
    {
      path: "/reportdetail/:issueId",
      name: "ReportDetail",
      beforeEnter: requireAuth,
      component: ReportDetail
    },
    {
      path: "/license",
      name: "License",
      beforeEnter: requireAuth,
      component: License
    },
    {
      path: "/degreeNotice",
      name: "DegreeNotice",
      beforeEnter: requireAuth,
      component: DegreeNotice
    },
    {
      path: "/licensePopulate",
      name: "AddLicense",
      beforeEnter: requireAuth,
      component: AddLicense
    },
    {
      path: "/licenseModify",
      name: "ModifyLicense",
      beforeEnter: requireAuth,
      component: ModifyLicense
    },
    {
      path: "/licenseImageModify",
      name: "ModifyLicenseImage",
      beforeEnter: requireAuth,
      component: ModifyLicenseImage
    },
    {
      path: "/viewLicense",
      name: "ViewLicense",
      beforeEnter: requireAuth,
      component: ViewLicense
    },
    {
      path: "/uploadLicense",
      name: "Upload License",
      beforeEnter: requireAuth,
      component: UploadLicense
    },
    {
      path: "/storetransfer",
      name: "StoreTransfer",
      component: StoreTransfer
    },
    {
      path: "/testcss",
      name: "TestCss",
      beforeEnter: requireAuth,
      component: TestCss
    },
    {
      path: "/board/:boardId",
      name: "Board",
      component: Board,
      beforeEnter: requireAuth,
      //meta: { TabType: "SocialLearningList", viewMode: "List" },
      children: [
        {
          path: "/",
          name: "BoardList",
          component: BoardList,
          beforeEnter: requireAuth
        },
        {
          path: ":postId",
          name: "BoardView",
          component: BoardView,
          beforeEnter: requireAuth
          //meta: { TabType: "BoardView", viewMode: "View" },
        },
        {
          path: "/perview-display",
          name: "PerviewFile",
          beforeEnter: requireAuth,
          component: PerviewFile
        }
      ]
    },
    {
      path: "/board-write/:boardId",
      name: "BoardWrite",
      beforeEnter: requireAuth,
      component: BoardWrite
    },
    {
      path: "/board-write/:boardId/:postId",
      name: "BoardModify",
      beforeEnter: requireAuth,
      component: BoardWrite
    },
    {
      path: "/store",
      name: "StoreManagement",
      beforeEnter: requireAuth,
      component: StoreManagement,
      meta: { TabType: "StoreList", viewMode: "List" },
      children: [
        {
          path: ":goodsId",
          name: "StoreView",
          component: StoreView,
          meta: { TabType: "StoreList", viewMode: "View" }
        },
        {
          path: "modify/:goodsId",
          name: "StoreModify",
          component: StoreModify
          // meta: { TabType: "StoreList", viewMode: "Modify" },
        },
        {
          path: "add/:goodsId",
          name: "StoreAdd",
          component: StoreAdd
          // meta: { TabType: "StoreList", viewMode: "Modify" },
        }
      ]
    },
    {
      path: "/search",
      name: "StoreProductCategory",
      component: StoreProductCategory
      // meta: { TabType: "StoreList", viewMode: "Modify" },
    },

    {
      path: "/barcode",
      name: "BarCodeReader",
      beforeEnter: requireAuth,
      component: BarCodeReader
    },
    {
      path: "/chat-image-large",
      name: "ChatImageInLarge",
      beforeEnter: requireAuth,
      component: ChatImageInLarge
    },
    {
      path: "/checklist",
      name: "CheckList",
      component: CheckList,
      beforeEnter: requireAuth
    },
    {
      path: "/checklist/:postId",
      name: "CheckListView",
      beforeEnter: requireAuth,
      component: CheckListView
    },
    {
      path: "/submit-result/:postId",
      name: "SubmittedResult",
      beforeEnter: requireAuth,
      component: SubmittedResult
    },
    {
      path: "/questiontake/:postId",
      name: "CheckListQuestionTake",
      beforeEnter: requireAuth,
      component: CheckListQuestionTake
    },
    {
      path: "/questiontake/comment/:postId",
      name: "CheckListComment",
      beforeEnter: requireAuth,
      component: CheckListComment
    }
  ]
});

// Check Brand Info
function checkBrandInfo() {
  return !!(
    localStorage.getItem("brandCode") &&
    localStorage.getItem("brandName") &&
    localStorage.getItem("brandLogo") &&
    localStorage.getItem("brandCompany")
  );
}

// 라우터 이동시 체크(router move check)
router.beforeEach((to, from, next) => {
  let isOnline = navigator.onLine;
  let routerPath = to.fullPath;
  let routerName = to.name;
  let redirectFromPath = encodeURIComponent(from.path);

  // Dynamic Link에 Brandcode가 있을때
  if(to.query && to.query.brandCode) {
    localStorage.removeItem("DYNAMIC_QUERY");
    const dynamicQueryData = {
      ...to.query,
      routerPath,
    }
    localStorage.setItem("DYNAMIC_QUERY", JSON.stringify(dynamicQueryData));
  } 

  if (isOnline) {
    let stateBrandInfo = checkBrandInfo();

    // 브랜드 선택화면이면
    if (routerName === "BrandSelect") {
      next();
    } else {
      // 브랜드 선택화면이 아니면(is brand select screen)
      if (routerName && routerName.indexOf("Dynamic") >= 0) {
        next();
        return false;
      }

      if (stateBrandInfo) {
        // 브랜드 정보 정상이면 언어 체크(language check)
        window.BRAND_CODE = localStorage.getItem("brandCode");
        window.BRAND_NAME = localStorage.getItem("brandName");
        window.BRAND_LOGO = localStorage.getItem("brandLogo");
        window.BRAND_COMPANY = localStorage.getItem("brandCompany");

        // 브랜드 담당자 정보 설정(set brand Manager info)
        brandApi.brandManager().then(response => {
          window.BRAND_MANAGER_NAME = response.data.data.name;
          window.BRAND_MANAGER_EMAIL = response.data.data.email;
          window.BRAND_MANAGER_PHONE = response.data.data.phone;
        });

        setUserLanguage().then(() => {
          if (routerPath === "Login") {
            const mainPath = `/login?redirectPath=${routerPath}`;
            next(mainPath);
          } else {
            next();
          }
        });
      } else {
        if(routerName && routerName.indexOf("Token") >= 0) {
          localStorage.setItem(storageConstants.redirectPath, routerName);
        }
        const mainPath = `/?redirectPath=${routerPath}`;
        next(mainPath);
      }
    }
  } else {
    if (routerPath.indexOf("error") === -1) {
      next("/error/network?redirectPath=" + redirectFromPath);
    } else {
      next();
    }
  }
});

export default router;
